export const persistedAddinEndpoint: string = '/ows/api/beta/PersistedAddins';
